// extracted by mini-css-extract-plugin
export var cyan = "Button-module--cyan--10e26";
export var orange = "Button-module--orange--34ef7";
export var pink = "Button-module--pink--1750a";
export var purple = "Button-module--purple--af73e";
export var rainbow = "Button-module--rainbow--6927c";
export var red = "Button-module--red--b3e13";
export var root = "Button-module--root--6b41f";